module.exports = __webpack_public_path__ + "static/media/we_got_stems.55272667.jpg";